import { Autocomplete as RtAutocomplete } from 'react-toolbox/lib/autocomplete';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import React from 'react';

import {
  RTAutocomplete as RTAutocompleteTheme,
  RTInput as RTInputTheme,
} from '../../assets/react-toolbox/theme';
import InfoLabel from './InfoLabel';

export const toggleThemePaletteType = type => (type === 'light' ? 'dark' : 'light');

export const styles = theme => ({
  root: {
    [`& .${RTAutocompleteTheme.autocomplete}`]: {
      width: '100%',
      padding: '0',
      '&>div::after': {
        // this is used for the dropdown arrow.
        borderTopColor: theme.palette.text.secondary,
        top: '35px',
      },
      '& ul': {
        padding: '5px 2px',
        zIndex: 100,
      },
      '& ul li:hover': {
        backgroundColor: `${theme.palette.primary.main} !important`,
        borderRadius: '4px',
        color: '#fff !important',
        boxShadow: `0 2px 2px ${theme.palette.action.disabled}`,
      },
      '& ul li': {
        padding: '4px 6px',
        fontSize: '14px',
      },
      '& input': {
        border: `1px solid ${theme.palette.grey[400]}`,
        borderBottomStyle: 'solid !important',
        borderRadius: '4px',
        color: theme.palette.text.primary,
        padding: '9px 25px 9px 11px',
        height: '40px',
        background: '#fff',

        '&:focus': {
          borderColor: `${theme.palette.primary.main} !important`,
        },

        '&[disabled]': {
          background: theme.palette.action.disabledBackground,
          opacity: '.5',
        },
      },
      '& span': {
        color: theme.palette.text.secondary,
        '&:before': {
          display: 'none !important',
        },
        '&:after': {
          display: 'none !important',
        },
      },
      '& label': {
        color: theme.palette.text.secondary,
        top: `-3px !important`,
        fontSize: '13px !important',
      },
    },
    [`& .${RTAutocompleteTheme.suggestions}`]: {
      overflowY: 'auto',
      '&::-webkit-scrollbar': {
        all: 'initial',
      },
      '&::-webkit-scrollbar-track': {
        background: `${theme.palette.grey[100]}`,
      },
      '&::-webkit-scrollbar-thumb': {
        background: `${theme.palette.grey[400]}`,
      },
      [`&:not(.${RTAutocompleteTheme.up})`]: {
        marginTop: '-5px',
      },
    },
    [`& .${RTInputTheme.errored} > .${RTInputTheme.inputElement}`]: {
      border: `1px solid ${theme.palette.error.main} !important`,
    },
    [`& .${RTInputTheme.errored} > .${RTInputTheme.label}`]: {
      color: theme.palette.error.main,
    },
    [`& .${RTInputTheme.errored} > .${RTInputTheme.error} *`]: {
      color: theme.palette.error.main,
    },
    [`& .${RTInputTheme.label}`]: {
      lineHeight: '1',
    },
    [`& .${RTInputTheme.input}`]: {
      padding: '16px 0 0 0',
    },
    [`& .${RTInputTheme.hint}`]: {
      top: '28px',
      left: '13px',
    },
    [`& .${RTInputTheme.inputElement}`]: {
      '&:focus': {
        '&:not([disabled])': {
          '&:not([readonly])': {
            [`&~.${RTInputTheme.label}`]: {
              [`&:not(.${RTInputTheme.fixed})`]: {
                color: theme.palette.primary[toggleThemePaletteType(theme.palette.type)],
              },
              [`& .${RTInputTheme.required}`]: {
                color: theme.palette.primary[toggleThemePaletteType(theme.palette.type)],
              },
            },
          },
        },
      },
    },
  },
});

const applyRequiredFieldIndicator = labelText => labelText + ' *';

export const Autocomplete = ({
  direction,
  suggestionMatch,
  showSuggestionsWhenValueIsSet,
  label,
  source,
  disabled,
  multiple = true,
  classes,
  helperText,
  FormHelperTextProps,
  required,
  className,
  hint,
  inputProps,
  input: { value, onBlur, onChange },
  meta: { touched, error },
  enableQueryChange,
  infoTooltip,
}) => {
  const hasError = touched && !!error;

  return (
    <FormControl
      className={classnames(className, classes.root)}
      disabled={disabled}
      fullWidth
      margin="normal"
    >
      <RtAutocomplete
        {...inputProps}
        required={required && !infoTooltip}
        error={hasError && error}
        direction={direction}
        suggestionMatch={suggestionMatch}
        showSuggestionsWhenValueIsSet={showSuggestionsWhenValueIsSet}
        label={
          infoTooltip ? (
            <InfoLabel
              label={required ? applyRequiredFieldIndicator(label) : label}
              tooltip={infoTooltip}
            />
          ) : (
            label
          )
        }
        source={source}
        disabled={disabled}
        onBlur={() => onBlur()}
        onChange={value => onChange(value)}
        onQueryChange={query => enableQueryChange && onChange(query)}
        multiple={multiple}
        selectedPosition="below"
        value={value}
        hint={hint}
        // eslint-disable-next-line iqvia/ternaries/no-empty-ternary
        title={value && source && source[value] ? source[value] : ''}
      />
      {helperText && <FormHelperText {...FormHelperTextProps}>{helperText}</FormHelperText>}
    </FormControl>
  );
};

Autocomplete.displayName = 'Autocomplete';

export default withStyles(styles, { name: 'Autocomplete' })(Autocomplete);



// WEBPACK FOOTER //
// ./src/Shared/Forms/Autocomplete.js